import { getCurrentUser } from '@/store/service'
import * as firebase from "firebase"
require("firebase/firestore")

export const getFavorites = uid => {
  let reference = firebase.firestore().collection('users').doc(uid).collection('favorites')

  return (
    reference
    .get()
    .then(snapshots => {
      let favorites = []
      snapshots.forEach(snapshot => {
        favorites.push(snapshot.id)
      })
      return favorites
    })
  )
}

export const removeFavorite = videoId => {
  let user = getCurrentUser()
  let reference = firebase.firestore().collection('users').doc(user.uid).collection('favorites').doc(videoId)

  return (
    reference.delete()
    .then(() => {
      return true
    })
    .catch(() => {
      return false
    })
  )
}

export const addFavorite = videoId => {
  let user = getCurrentUser()
  let reference = firebase.firestore().collection('users').doc(user.uid).collection('favorites').doc(videoId)

  return (
    reference.set({
      created_at: firebase.firestore.FieldValue.serverTimestamp()
    })
    .then(() => {
      return true
    })
    .catch(() => {
      return false
    })
  )
}
